import InputField from "../../InputField";

import styles from "./CarBasicInfo.module.css";

const CarBasicInfo = ({ formik }) => {

    const {

        values,

        errors,

        touched,

        handleChange,

        handleBlur,

    } = formik;

    return (

        <section className={styles.section}>

            <div className={styles.header}>

                <h3>
                    اطلاعات اصلی خودرو
                </h3>

                <p>
                    اطلاعات پایه خودرو را وارد کنید.
                </p>

            </div>

            <div className={styles.grid}>

                <InputField
                    id="title"
                    name="title"
                    label="نام خودرو"
                    autoComplete="off"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.title && errors.title}
                    touched={touched.title}
                    required
                />

                <InputField
                    id="company"
                    name="company"
                    label="شرکت سازنده"
                    autoComplete="organization"
                    value={values.company}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.company && errors.company}
                />

                <InputField
                    id="shasiNo"
                    name="shasiNo"
                    label="شماره شاسی"
                    autoComplete="off"
                    value={values.shasiNo}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.shasiNo && errors.shasiNo}
                />

            </div>

        </section>

    );

};

export default CarBasicInfo;